import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('SteamOnNews').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '90%',
    cursor: 'pointer',
    height: '120px',
    background: 'black',
    borderRadius: theme.sizes.radiuses.l,

    img: {
      borderRadius: '12px',
      width: '100%',
      transformOrigin: 'center center',
    },
  },

  wrapper: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    top: '6px',
    left: '12px',
    minWidth: '150px',
    width: '50%',
    height: '100%',
    padding: '12px 0px',
    gap: '20px',
  },
  heading: {
    zIndex: '5',
    display: 'block',
    textAlign: 'center',
    fontFamily: 'Inter',
    width: '100%',
    fontWeight: '700',

    fontSize: '20px',

    lineHeight: '100%',

    letterSpacing: '-1%',

    verticalAlign: 'middle',
  },

  voteForGamed: {
    borderRadius: theme.sizes.radiuses.l,
    alignSelf: 'center',
    background: 'linear-gradient(180deg, #5EBEF0 0%, #0395FD 100%)',
    boxShadow: '0px 0px 10px 3px rgba(41, 144, 255, 1)',
    padding: '5px 8px',
  },
}))
